import { Button } from 'design-system';
import { FcGoogle } from 'react-icons/fc';

export const GoogleLoginButton = () => {
  const handleClick = () => {
    window.location.assign(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/google?redirect=${window.location.origin}`);
  };

  return (
    <Button
      onClick={handleClick}
      w='100%'
      h='48px'
      leftIcon={<FcGoogle size='22px' />}
      variant='outline'
      color='gray.600'
      fontWeight='500'>
      Continue with Google
    </Button>
  );
};
